import { useMemo } from "react";

import { Icon, Tooltip } from "./ui.js";

import { useSelectionContext } from "./contexts/selection-context.js";

function roundIfNeeded(width) {
    return Number(width).toFixed(2).replace(/\.0+$/, "");
}

export function ColumnSizeIndicator({ size, onClick }) {
    const { selection } = useSelectionContext();
    const { unit, width } = size;
    const formattedWidth = useMemo(() => {
        if (unit === "custom") {
            return width;
        }
        return `${roundIfNeeded(width)}${unit}`;
    }, [unit, width]);

    if (!selection) {
        return null;
    }

    return (
        <Tooltip
            message={
                unit === "custom"
                    ? "사용자 지정 열 너비입니다. 클릭하여 변경"
                    : `열 너비 ${formattedWidth}. 클릭하여 변경`
            }
        >
            <button className="table-generator-column-indicator-button" type="button" onClick={onClick}>
                <Icon name="expand" size="11px" color="var(--table-generator-toolbar-button-color)" />
                <span className="table-generator-column-indicator-label">{formattedWidth}</span>
            </button>
        </Tooltip>
    );
}
